package co.uk.sacursoftware.ssinventory.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.browser.document
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader

actual class PlatformFilePicker(
    private val onPick: () -> Unit
) {
    actual fun pickFile() = onPick()
}

@Composable
actual fun rememberPlatformFilePicker(
    onFilePicked: (ByteArray, String) -> Unit
): PlatformFilePicker {
    return remember {
        PlatformFilePicker {
            val input = document.createElement("input") as HTMLInputElement
            input.type = "file"
            input.accept = "*/*"
            input.onchange = { _ ->
                val files = input.files
                if (files != null && files.length > 0) {
                    val file = files.item(0)
                    if (file != null) {
                        val reader = FileReader()
                        reader.onload = { _ ->
                            val arrayBuffer = reader.result
                            val uint8Array = js("new Uint8Array(arrayBuffer)") as org.khronos.webgl.Uint8Array
                            val byteArray = ByteArray(uint8Array.length)
                            for (i in 0 until uint8Array.length) {
                                byteArray[i] = uint8Array.asDynamic()[i] as Byte
                            }
                            onFilePicked(byteArray, file.name)
                            null
                        }
                        reader.readAsArrayBuffer(file)
                    }
                }
                null
            }
            input.click()
        }
    }
}
